import moneyHelper from '../../helpers/money';
import { createExtra, toggleExtra } from '../../actions';
import { GtmDataLayer } from '../../data/gtmDataLayer';
import Amount from "../../helpers/amount";

const cssClasses = {
    extra: 'extra',
    extraActive: 'extra--active',
    extraInput: 'extra__input',
    extraLabel: 'extra__label',
    extraPrice: 'extra__price',
};

export class ExtraInput {
    constructor(options) {
        this.store = options.store;
        this.state = this.store.getState();
        this.id = options.id;
        this.name = options.name;
        this.amount = options.amount;
        this.extraType = options.extraType;
        this.active = options.active;
        this.modal = options.modal;
        this.$el = this.createExtraInputElement(
            options.name,
            options.label,
            options.labelType,
            options.amount,
            options.description,
            options.readMoreLink,
            options.active
        );

        if (!this.state.extras) {
            this.store.dispatch(createExtra(
                options.id,
                options.extraType,
                options.name,
                options.label,
                options.labelType,
                options.amount,
                options.description,
                options.readMoreLink,
                options.active,
            ));
        }
        this.store.subscribe(this.update.bind(this));

        this.update();
    }

    createExtraInputElement(
        title = '',
        label = '',
        labelType = 0,
        amount = 0,
        description = '',
        readMoreLink = '',
    ) {
        const $extraElem = document.createElement('div');
        const labelTypes = [
            'extra__label label--green icon--before icon--check-green',
            'extra__label label--blue icon--before icon--check-blue',
        ];

        const extraElemHTML = `
            <div class="row row--head">
                <div class="col-12"><h5 class='extra__title'>${title}</h5><span class="${labelTypes[labelType - 1]}">${label}</span></div>
            </div>
            <div class="row">
                <div class="col-12"><div class='extra__description'>${description} ${readMoreLink !== '' ? `<a href="${readMoreLink}" data-modal='${readMoreLink}'>${__('Read more')}</a>` : ''}</div></div>
            </div>
            <div class="row row--foot">
                <div class="col-12 col--toggle-button"><span class='extra__price h5'>${moneyHelper.formatPrice(amount)}</span></div>
            </div>
        `;

        this.$toggleButton = this.createToggleButton();

        $extraElem.classList.add('extra');
        $extraElem.innerHTML = extraElemHTML;

        const modalLink = $extraElem.querySelector('[data-modal]');

        if (modalLink) {
            modalLink.addEventListener('click', (event) => {
                event.preventDefault();
                if (modalLink.getAttribute('data-modal').includes('.pdf')) {
                    this.modal.setContent(`<object width="100%" data="${modalLink.getAttribute('data-modal')}"></object>`);
                } else {
                    this.modal.setContent(`<iframe src="${modalLink.getAttribute('data-modal')}" frameborder="0" sandbox="allow-same-origin allow-scripts allow-popups allow-forms"></iframe>`);
                }
                this.modal.open();
            });
        }

        $extraElem.querySelector('.col--toggle-button').appendChild(this.$toggleButton);

        const gtmProductData = {
            name: this.name,
            id: this.id,
            price: this.amount,
            quantity: 1,
            productCode: this.state.product.productCode,
            packageCode: this.state.product.packageCode,
        };
        const gtmStepData = {
            name: this.state.steps.find(step => step.current === true).name,
            id: this.state.steps.find(step => step.current === true).id,
        };

        if (this.active) {
            GtmDataLayer.addToCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
        }

        return $extraElem;
    }

    createToggleButton() {
        const $buttonElem = document.createElement('button');
        const $buttonInnerElem = document.createElement('span');

        $buttonInnerElem.innerHTML = `${ this.active ? __('Added') : __('Add')}`;
        $buttonElem.type = 'button';
        $buttonElem.classList.add('btn', 'btn-sm', 'btn-light-blue');
        $buttonElem.classList.add('btn--toggle');
        $buttonInnerElem.classList.add('btn__inner', 'icon--before');
        $buttonInnerElem.classList.toggle('icon--plus', !this.active);
        $buttonInnerElem.classList.toggle('icon--check', this.active);
        $buttonElem.appendChild($buttonInnerElem);

        $buttonElem.addEventListener('click', () => {
            this.active = !this.active;
            this.store.dispatch(toggleExtra(this.extraType, this.active));
            $buttonInnerElem.innerHTML = `${ this.active ? __('Added') : __('Add')}`;
            $buttonInnerElem.classList.toggle('icon--plus', !this.active);
            $buttonInnerElem.classList.toggle('icon--check', this.active);

            const gtmProductData = {
                name: this.name,
                id: this.id,
                price: this.amount,
                quantity: 1,
                productCode: this.state.product.productCode,
                packageCode: this.state.product.packageCode,
            };
            const gtmStepData = {
                name: this.state.steps.find(step => step.current === true).name,
                id: this.state.steps.find(step => step.current === true).id,
            };

            if (this.active) {
                GtmDataLayer.addToCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
            } else {
                GtmDataLayer.removeFromCart(gtmProductData, gtmStepData, Amount.calculateTotalAmountIncludingExtras(this.state));
            }

        }, true);

        return $buttonElem;
    }

    updateExtraInput(extra) {
        this.$el.classList.toggle(cssClasses.extraActive, extra.active);
    }

    update() {
        this.state = this.store.getState();

        const updatedExtra = this.state.extras.find(extra => extra.extraType === this.extraType);
        this.updateExtraInput(updatedExtra);
    }

    render() {
        return this.$el;
    }
}

export default ExtraInput;
